<template>
  <div class="modal modal-open items-start !animate-none overflow-y-auto">
    <div
      class="absolute top-0 bottom-0 right-0 left-0"
      @click.prevent="$emit('close')"
    />
    <div class="modal-box pt-4 pb-6 px-6 mt-20 max-h-none w-full max-w-md">
      <div class="flex justify-between items-center border-b pb-2 mb-2 font-medium">
        <span class="text-lg">
          {{ title }}
        </span>
        <a
          href="#"
          class="text-xl"
          @click.prevent="$emit('close')"
        >&times;</a>
      </div>
      <div class="py-4">
        <p dir="auto">{{ message }}</p>
      </div>
      <div class="flex justify-end">
        <button
          class="base-button"
          @click.prevent="$emit('close')"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertModal',
  props: {
    message: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: 'Alert'
    }
  },
  emits: ['close'],
  mounted () {
    document.addEventListener('keyup', this.handleEscape)
  },
  beforeUnmount () {
    document.removeEventListener('keyup', this.handleEscape)
  },
  methods: {
    handleEscape (e) {
      if (e.code === 'Escape') {
        this.$emit('close')
      }
    }
  }
}
</script>
